import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, HostListener } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslocoService } from "@ngneat/transloco";
import {
  MenuItem,
  Message,
  MessageService,
} from "primeng/api";
import { Project } from "src/app/model/form/project";
import { Image } from "src/app/model/Image";
import { Vcu } from "src/app/model/form/vcu";
import { LogProject } from "src/app/model/log-project";
import { MapProject } from "src/app/model/map-project";
import { Share } from "src/app/model/share";
import { ProjectService } from "src/app/service/project.service";
import { Vehicle } from "src/app/model/vehicle";
import { AccountService } from "src/app/service/account.service";
import { VcuService } from "src/app/service/vcu.service";
import { IMAGE_DEFAULT } from "src/app/model/mockup/image-mockup";
import { FamilyService } from "src/app/service/family.service";
import { ModelService } from "src/app/service/model.service";
import { ResellerService } from "src/app/service/reseller.service";
import { forkJoin, Subject, takeUntil } from "rxjs";
import { AuthService } from "src/app/service/auth.service";



@Component({
  selector: 'app-public-project-details',
  templateUrl: './public-project-details.component.html',
  styleUrls: ['./public-project-details.component.css']
})
export class PublicProjectDetailsComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();



  @ViewChild("fileInputMap", { static: false }) fileInputMap!: ElementRef;
  @ViewChild("fileInputLog", { static: false }) fileInputLog!: ElementRef;

  items: MenuItem[] | undefined;
  logs: LogProject[];
  maps: MapProject[];
  shares: Share[];
  vcus: Vcu[];
  project: Project | null;
  responsiveOptions: any[] | undefined;
  backupLog: LogProject | null = null;
  backupMap: MapProject | null = null;
  projectsEdit: Project[];
  showVcuDialog: boolean = false;
  showEditProjectDialog: boolean = false;
  selectedImage: string | null = null;
  listSharedArchives: any[] = [];
  selectedSharedArchive: any[] = [];
  selectedFiles: File[] | null = null;

  loadingLog: boolean = false;
  loadingMap: boolean = false;
  loadingShare: boolean = false;
  loadingShareArchives: boolean = true;
  loadingProject: boolean = false;

  vehicle = new Vehicle();
  token: string | null = "";
  emailShare: string = "";
  userID: string = "";
  userNickname: string = "";
  userName: string = "";
  projectID: string = "";
  projectName: string = "";

  vcuUnlink: Vcu | null = null;
  showDialogUnlink: boolean = false;
  projectUnlinkInvalid: string = "";
  unlinkVcuBtnLoading: boolean = false;
  reasonUnlinkVcu: string = "";
  messages: Message[] = [];
  dashboardUrl: string = "/my-garage";

  familyOptions: any[] = [];
  modelOptions: any[] = [];
  resellerOptions: any[] = [];

  isProjectShared: boolean = false;
  userOwnerID: string = "";
  baseUrl: string = "/project/public/";
  publicUrl: string = "";
  labelUrl: string = "www.hml.fueltech.cloud/project/public/";
  sharingProjectType: number = 0;
  classPublicUrl: string = "";

  projectsPerPage = 2;
  currentIndex = 0;
  currentIndexShared = 0;

  visibleThumbs: Image[] = [];
  thumbStart = 0;
  visibleCount = 5;

  showShareArchiveDialog: boolean = false;
  infoSharedArchivesDialog: boolean = false;

  isEmailType: boolean = false;
  isFTCloudType: boolean = false;
  isLinkType: boolean = false;
  emailArchivesShare: string = "";
  shareArchivesEmail: string[] = [];
  shareArchivesFileID: string = "";
  shareArchivesTypeFile: string = "";
  linkVisible: string = "";
  shareIn: string = "";

  isLoading: boolean = false;
  
  progressState: string = "";
  progressValue: number = 0;
  uploadedFiles: any[] = [];
  keyFiles: any[] = [];
  loadingSaveTask: boolean = false;
  disableSaveTask: boolean = false;
  displayUploadLogMap: boolean = false
  typeFileSelected: string = "";

  displayImage: boolean = false
  imageSelectedUrl: string = ""

  currentPage: number = 1;
  rowsPerPage: number = 5;
  totalRecords: number = 0;

  constructor(
    private translocoService: TranslocoService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private projectService: ProjectService,
    private accountService: AccountService,
    private messageService: MessageService,
    private familyService: FamilyService,
    private modelService: ModelService,
    private authService: AuthService,
    private resellerService: ResellerService,
    private vcuService: VcuService,
    private router: Router
  ) {
    this.showVcuDialog = false;
    this.project = null;
    this.vcus = [];
    this.logs = [];
    this.maps = [];
    this.shares = [];
    this.projectsEdit = [];

    this.loadingLog = false;
    this.loadingMap = false;
    this.loadingShare = false;

    const nav = this.router.getCurrentNavigation();
    if (nav?.extras.state) {
      this.userID = nav.extras.state['userID'];
      this.projectID = nav.extras.state['projectID'];
    }
  }

  ngOnInit(): void {
    this.setTitle();
    this.token = sessionStorage.getItem("token");
    // this.userID = this.authService.getUserInformations();
    this.changeLanguage();
    this.messageService.clear();
    window.scrollTo({ top: 0, behavior: "smooth" });

    this.initResponsiveOptions();

    if (this.token) {
      this.loadingProject = true;

      forkJoin({
        families: this.familyService.getAllFamily(),
        models: this.modelService.getAllModel(),
        resellers: this.resellerService.getAllReseller(),
      }).subscribe({
        next: ({ models}) => {
          this.modelOptions = ModelService.toItemList(models);

          // this.activatedRoute.params.subscribe((params) => {
            // this.projectID = params["id"];
            this.loadProjectData();
          // });
        },
        error: (error) => {
          console.error("Erro ao carregar opções:", error);
          this.loadingProject = false;
        },
      });
    }
}

private initResponsiveOptions(): void {
  this.responsiveOptions = [
    { breakpoint: "1430px", numVisible: 3, numScroll: 1 },
    { breakpoint: "1260px", numVisible: 2, numScroll: 1 },
    { breakpoint: "870px", numVisible: 1, numScroll: 1 },
  ];
}

private loadProjectData(): void {
  if (this.userID) {
    this.setProjectContextAndFetch();
  } else {
      this.accountService.findUserActive().subscribe((data) => {
        this.userID = data.userID;
        this.setProjectContextAndFetch();
      });
    }
}

private setProjectContextAndFetch(): void {
  this.vcuService.setUserID(this.userID);
  this.vcuService.setProjectID(this.projectID);
  this.fetchProject(this.userID, this.projectID);
}

private fetchProject(userID: string, projectID: string): void {
  this.projectService.getProject(userID, projectID).subscribe((dataProject) => {
    if (!dataProject) return;

    this.processVCUDescriptions(dataProject.vcus || []);
    this.reorderPrimaryPhoto(dataProject);

    this.accountService.getPublicAccount(dataProject.userID).subscribe((data) => {
      this.userName = data.name;
      this.userNickname = data.nickname;
      this.projectName = dataProject.projectName?.toLowerCase();
    });

    this.project = ProjectService.toProject(dataProject);
    this.vcus = this.project?.vcus ?? [];


    setTimeout(() => this.setTitle(dataProject.projectName), 0);
    this.setImageDefault();
    this.isProjectShared = dataProject.isSharing;
    this.userOwnerID = this.project.userID;

    if (this.project?.images?.length) {
      this.selectedImage = this.project.images[0].href ?? null;
      this.updateVisibleThumbs();
    }
        if (this.project?.images?.length) {
          this.selectedImage = this.project.images[0].href ?? null;
          this.updateVisibleThumbs();
        }
    this.loadingProject = false;
  });
}

private processVCUDescriptions(vcus: any[]): void {
    for (let vcu of vcus) {
      if (vcu.familyID) {
        const family = this.familyOptions.find((f) => f.id === vcu.familyID);
        vcu.familyDescription = family?.name;
      }

      const modelId = vcu.attributes?.model;
      if (modelId) {
        vcu.modelID = modelId.toString();
        const model = this.modelOptions.find((m) => m.id === modelId);
        vcu.modelDescription = model?.name;
      }

      if (vcu.resellerID) {
        const reseller = this.resellerOptions.find(
          (r) => r.id === vcu.resellerID
        );
        vcu.resellerDescription = reseller?.name;
      }
    }
  }


private reorderPrimaryPhoto(dataProject: any): void {
  const attrs = dataProject.attributes;
  if (attrs?.photo && attrs.primaryImage) {
    let photoArray = attrs.photo.split(",");
    const primaryIndex = photoArray.indexOf(attrs.primaryImage);
    if (primaryIndex !== -1) {
      photoArray.splice(primaryIndex, 1);
      photoArray.unshift(attrs.primaryImage);
    }
    attrs.photo = photoArray.join(",");
  }
}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setTitle(title?: string) {
    if (title) {
      this.titleService.setTitle("FT Pilot - " + title);
    } else {
      this.translocoService
        .selectTranslate("title.project")
        .pipe(takeUntil(this.destroy$))
        .subscribe((value) => this.titleService.setTitle(value));
    }
  }

  setImageDefault() {
    if (this.project && this.project.images.length < 5) {
      for (let i = this.project.images.length; i < 5; i++) {
        this.project.images.push(IMAGE_DEFAULT);
      }
    }
  }

  public changeLanguage(languageCode?: string | null): void {
    if (!languageCode || languageCode === null)
      languageCode = sessionStorage.getItem("language");
    if (languageCode && languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  getCurrentDate(): string {
  const now = new Date();

  const pad = (n: number) => n.toString().padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();

  return `${day}-${month}-${year}`;
}


  selectImage(imageHref: string) {
    this.selectedImage = imageHref;
  }

  prevImage() {
    if (!this.project?.images) return;
    const currentIndex = this.project.images.findIndex(
      (img) => img.href === this.selectedImage
    );
    const newIndex =
      currentIndex > 0 ? currentIndex - 1 : this.project.images.length - 1;
    this.selectedImage = this.project.images[newIndex].href ?? null;
  }

  nextImage() {
    if (!this.project?.images) return;
    const currentIndex = this.project.images.findIndex(
      (img) => img.href === this.selectedImage
    );
    const newIndex = (currentIndex + 1) % this.project.images.length;
    this.selectedImage = this.project.images[newIndex].href ?? null;
  }

  updateVisibleThumbs() {
    if (this.project?.images) {
      this.visibleThumbs = this.project?.images.slice(
        this.thumbStart,
        this.thumbStart + this.visibleCount
      );
    }
  }

  prevThumbs() {
    if (this.thumbStart > 0) {
      this.thumbStart -= this.visibleCount;
      if (this.thumbStart < 0) this.thumbStart = 0;
      this.updateVisibleThumbs();
    }
  }

  nextThumbs() {
    if (
      this.project?.images &&
      this.thumbStart + this.visibleCount < this.project.images.length
    ) {
      this.thumbStart += this.visibleCount;
      this.updateVisibleThumbs();
    }
  }

  get totalPages(): number {
    const projects = this.project?.vcus || [];
    return Math.ceil(projects.length / this.projectsPerPage);
  }

  nextSlide() {
    if (this.currentIndex < this.totalPages - 1) {
      this.currentIndex++;
    }
  }

  prevSlide() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

private showMessage(
  severity: 'success' | 'error' | 'info' | 'warn',
  summary: string,
  detail: string
): void {
  this.messageService.clear();
  this.messageService.add({
    key: 'toastProject',
    severity,
    summary,
    detail,
  });
}

private showTranslocoError(key: string) {
  this.translocoService.selectTranslate(key).subscribe((value) => {
    this.showMessage("error", value.header, value.message);
  }).unsubscribe();
}

private showTranslocoErrorWithKey(key: string) {
  this.translocoService.selectTranslateObject("project.register").subscribe((value) => {
    this.showMessage("error", value.header, value[key.split('.').pop() || ""]);
  }).unsubscribe();
}

private showTranslocoErrorCustom(message: string) {
  this.translocoService.selectTranslateObject("project.register").subscribe((value) => {
    this.showMessage("error", value.header, message);
  }).unsubscribe();
}

  lightboxIndex = 0;
  private touchStartX = 0;
  private touchEndX = 0;

  @HostListener('document:keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    if (!this.displayImage) return;
    if (event.key === 'Escape') {
      this.displayImage = false;
      document.body.style.overflow = '';
    } else if (event.key === 'ArrowLeft') {
      this.lightboxPrev(new MouseEvent('click'));
    } else if (event.key === 'ArrowRight') {
      this.lightboxNext(new MouseEvent('click'));
    }
  }

  openImage(image: string) {
    this.imageSelectedUrl = image;
    this.lightboxIndex = this.project?.images?.findIndex(img => img.href === image) ?? 0;
    if (this.lightboxIndex < 0) this.lightboxIndex = 0;
    this.displayImage = true;
    document.body.style.overflow = 'hidden';
  }

  closeLightbox(event: MouseEvent) {
    if ((event.target as HTMLElement).classList.contains('lightbox-overlay')) {
      this.displayImage = false;
      document.body.style.overflow = '';
    }
  }

  lightboxPrev(event: MouseEvent) {
    event.stopPropagation();
    if (!this.project?.images) return;
    this.lightboxIndex = this.lightboxIndex > 0
      ? this.lightboxIndex - 1
      : this.project.images.length - 1;
    this.imageSelectedUrl = this.project.images[this.lightboxIndex].href ?? '';
  }

  lightboxNext(event: MouseEvent) {
    event.stopPropagation();
    if (!this.project?.images) return;
    this.lightboxIndex = (this.lightboxIndex + 1) % this.project.images.length;
    this.imageSelectedUrl = this.project.images[this.lightboxIndex].href ?? '';
  }

  lightboxGoTo(index: number) {
    if (!this.project?.images) return;
    this.lightboxIndex = index;
    this.imageSelectedUrl = this.project.images[index].href ?? '';
  }

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) {
        this.lightboxNext(new MouseEvent('click'));
      } else {
        this.lightboxPrev(new MouseEvent('click'));
      }
    }
  }

}
